import request from '@/utils/httpRequest'

export default class RefundService {
  queryById (id) {
    return request({
      url: '/finance/wuyeFinanceRefundApply/queryById',
      method: 'get',
      params: {id: id}
    })
  }
  
  startFlow (params) {
    return request({
      url: '/finance/wuyeFinanceRefundApply/startFlow',
      method: 'post',
      data: params
    })
  }
}
